// extracted by mini-css-extract-plugin
export default {"backgroundContainer":"CreatePostForm_backgroundContainer__-iMnD","container":"CreatePostForm_container__j2aIN"};